import { alpha, CardHeader, useTheme } from '@mui/material';
import { ErrorOutline as ErrorIcon } from '@mui/icons-material';

import { DialogTitleTruncated, IDialogTitleTruncatedProps } from '/shared/DialogTitleTruncated';

import { IConfirmDialogHeaderProps } from '../types';
import { IconBackground } from '../styles';

export const ConfirmDialogHeader = (props: IConfirmDialogHeaderProps) => {
  const { maxWidth, title, mainColor } = props;
  const theme = useTheme();

  const titleProps: IDialogTitleTruncatedProps = {
    title: title || '',
    titleWrapperProps: {
      children: (
        <IconBackground
          sx={{
            p: 1.2,
            backgroundColor: alpha(mainColor.hex, 0.1),
          }}
        >
          <ErrorIcon />
        </IconBackground>
      ),
      sx: { color: mainColor.hex, display: 'flex', alignItems: 'center' },
      offset: 30,
    },
    titleProps: { variant: 'h5' },
    maxWrapperWidth: theme.breakpoints.values[maxWidth],
    maxVisibleTitleSymbols: 45,
  };

  return <CardHeader title={<DialogTitleTruncated {...titleProps} />} />;
};
